export enum MemberRegistrationType {
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER',
}
